__turbopack_context__.v({
  "lastPosition": "tableYearsNavArrows-module-scss-module__kGvW-W__lastPosition",
  "navTableArrow": "tableYearsNavArrows-module-scss-module__kGvW-W__navTableArrow",
});
